import { Component, OnInit } from "@angular/core";
import { filter } from "rxjs/operators";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/public_api";
import { PedidoService } from "src/app/core/services/pedido-service";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import { InitProvider } from "src/app/core/services/init-provider";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { OrderClient } from "src/app/core/entities/orderClient";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { LogService } from "src/app/core/services/log-service";
import { formatDate, Location } from "@angular/common";
import { ToastrService } from "ngx-toastr";

declare var $: any;

@Component({
  selector: "app-page-new-order",
  templateUrl: "./page-new-order.component.html",
  styleUrls: ["./page-new-order.component.css"],
})
export class PageNewOrderComponent implements OnInit {
  SITE: ConfiguracoesSite;
  abrePedidoEmGrupo: boolean;

  public error: Boolean = false;
  public errorMsg: String[] = [];
  public form: FormGroup;
  public abrindoPedido = false;
  isCopy: boolean = false
  term: string = "";
  tipoSelecionado: any;
  noResult = false;
  selectedCliente: any;
  listCliente: any = [];
  tabelas: any = [];
  public dateFormat = $localize`DD/MM/YYYY`
  pedidoTiposUsuario: any = [];
  /** Evita que setValue programático da filial dispare carga duplicada de tabelas. */
  aplicandoDadosCliente = false;
  /** Cache getTabelas por cliente + filial (evita nova requisição ao reabrir o mesmo cliente no badge). */
  tabelasPorClienteFilial = new Map<string, any[]>();
  clienteDetail: any = {};

  filiais: any = [];
  filial_Estoque: any = [];
  errorClienteTabela = false;
  errorClienteBloqueado = false;

  dataEntregaMinDate: Date;
  dataEntregaDaysDisable = [];
  clienteIdErp = {};
  pedidoOriginal;
  erroMensagemBloqueio: any;
  cidades?: any;

  get abrirPedidoDisabled(): boolean {
    return (
      this.listCliente.length < 1 ||
      this.abrindoPedido ||
      !!this.pedidoService.loading
    );
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private initProvider: InitProvider,
    private usuarioService: UsuarioService,
    private localeService: BsLocaleService,
    private pedidoService: PedidoService,
    private logService: LogService,
    private activeRoute: ActivatedRoute,
    public toastService: ToastrService,
    private location: Location
  ) {
    this.selectedCliente = {}
    this.isCopy = this.router.url === "/copia-pedido"
    this.SITE = Configuracoes.SITE;
    this.abrePedidoEmGrupo = Configuracoes.abrePedidoEmGrupo
    this.dataEntregaMinDate = new Date();
    this.tipoSelecionado = "";

    if (
      this.dataEntregaMinDate.getHours() > this.SITE.dataEntregaHorarioLimite
    ) {
      this.dataEntregaMinDate.setDate(
        this.dataEntregaMinDate.getDate() +
        1 +
        this.SITE.dataEntregaCarenciaPrazo
      );
    } else {
      this.dataEntregaMinDate.setDate(
        this.dataEntregaMinDate.getDate() + this.SITE.dataEntregaCarenciaPrazo
      );
    }
    this.dataEntregaDaysDisable = JSON.parse(
      "[" + this.SITE.dataEntregaDiasDesabilitados + "]"
    );
    this.localeService.use("pt-custom");

    // this.filiais = initProvider.filiais;
    this.form = this.formBuilder.group({
      tabela: ["", Validators.required],
      pedidoTipo: ["", Validators.required],
      filialEstoque: [""],
    });
    if (this.SITE.mostraDataEntrega) {
      this.form.addControl(
        "dataEntrega",
        new FormControl("", [Validators.required])
      );
    }
    if (this.filiais.length === 1) {
      this.form.addControl(
        "filial",
        new FormControl(this.filiais[0].id, [Validators.required])
      );
      this.selecionaFilial(this.filiais[0].id);
    } else {
      this.form.addControl(
        "filial",
        new FormControl("", [Validators.required])
      );
    }

    this.pedidoOriginal = this.router.getCurrentNavigation().extras.state;

    if (this.pedidoOriginal) {
      for (let cliente_ in this.pedidoOriginal.clientes) {
        this.selecionaCliente(this.pedidoOriginal.clientes[cliente_].cliente);
        $("#cliente").val("");
      }

      this.form.controls["tabela"].setValue(this.pedidoOriginal.tabela.id);
      this.form.controls["pedidoTipo"].setValue(this.pedidoOriginal.tipo.id);

      if (
        this.pedidoOriginal.dataEntrega &&
        this.pedidoOriginal.dataEntrega != null
      )
        this.form.controls["dataEntrega"].setValue(
          this.pedidoOriginal.dataEntrega
        );
    }
  }

  results: string[] = [];

  buscandoClientes = false;

  /** Enquanto busca detalhes (getClientesId) após escolher um cliente na lista. */
  clienteDetalheCarregando = false;

  get clienteSelecionado(): boolean {
    return !!this.selectedCliente && !!this.selectedCliente.id;
  }

  get clienteIntegrado(): boolean {
    const c: any = this.selectedCliente;
    if (!c || !c.id) {
      return true;
    }
    return Array.isArray(c.enderecos) && c.enderecos.length > 0;
  }

  private static readonly BUSCA_MIN = 2;

  private debounceTimer: any;
  private lastParams = "";

  private debounceBuscarClientes(params: { busca: string; id_usuario: any }) {
    clearTimeout(this.debounceTimer);
    this.buscandoClientes = true;
    this.debounceTimer = setTimeout(() => {
      const p = JSON.stringify(params);
      if (p !== this.lastParams) {
        this.lastParams = p;
        this.usuarioService.getClientes(
          params,
          function (resp) {
            this.results = resp;
            this.buscandoClientes = false;
          }.bind(this)
        );
      } else {
        this.buscandoClientes = false;
      }
    }, 0);
  }

  /**
   * Busca automática: após 1s sem digitar (typeahead) + mín. 2 caracteres.
   * Botão Buscar força com 2+ caracteres.
   */
  searchFunction = async (value: string, forceSearch = false) => {
    const v = (value ?? "").trim();
    if (!v) {
      this.results = [];
      this.buscandoClientes = false;
      this.lastParams = "";
      return;
    }
    if (!forceSearch && v.length < PageNewOrderComponent.BUSCA_MIN) {
      this.buscandoClientes = false;
      return;
    }
    this.debounceBuscarClientes({
      busca: v,
      id_usuario: this.initProvider.usuario.id,
    });
  };

  handleSelection = (value: string) => {
    this.selecionaCliente(value);
    this.results = []
  };

  handleSelectionCopy = (value: string) => {
    this.selecionaClienteCopy(value);
    this.results = []
  };

  select(param) {
    this.clienteIdErp[this.selectedCliente.id] = param;
  }

  private chaveCacheTabelas(clienteId: any, filialId: any): string {
    return `${clienteId}_${String(filialId)}`;
  }

  private invalidarCacheTabelasCliente(clienteId: any) {
    const prefix = `${clienteId}_`;
    for (const key of [...this.tabelasPorClienteFilial.keys()]) {
      if (key.startsWith(prefix)) {
        this.tabelasPorClienteFilial.delete(key);
      }
    }
  }

  private clienteDetalhadoEmMemoria(c: any): boolean {
    return (
      Array.isArray(c?.filiais) &&
      Array.isArray(c?.filial_estoque) &&
      Array.isArray(c?.enderecos)
    );
  }

  private aplicarListaTabelasDoServico(lista: any[], preferTabelaId?: any) {
    this.tabelas = lista;
    const pref =
      preferTabelaId !== null &&
      preferTabelaId !== undefined &&
      preferTabelaId !== "";
    if (pref) {
      const found = lista.find(
        (t) => String(t.id) === String(preferTabelaId)
      );
      if (found) {
        this.form.controls.tabela.setValue(found.id);
        return;
      }
    }
    if (lista.length === 1) {
      this.form.controls.tabela.setValue(lista[0].id);
    } else {
      this.form.controls.tabela.setValue("");
    }
  }

  private carregarTabelasPreco(
    clienteId: any,
    filialId: any,
    preferTabelaId?: any
  ) {
    if (filialId === "" || filialId === null || filialId === undefined) {
      this.tabelas = [];
      this.form.controls.tabela.setValue("");
      return;
    }
    const key = this.chaveCacheTabelas(clienteId, filialId);
    const cached = this.tabelasPorClienteFilial.get(key);
    if (cached) {
      this.aplicarListaTabelasDoServico(cached.slice(), preferTabelaId);
      return;
    }
    this.usuarioService.getTabelas(
      clienteId,
      (resp) => {
        const lista = resp || [];
        this.tabelasPorClienteFilial.set(key, lista);
        this.aplicarListaTabelasDoServico(lista.slice(), preferTabelaId);
      },
      filialId
    );
  }

  private aplicarDadosClienteAposCarregar(
    resp: any,
    options?: { preferTabelaId?: any; copiaTipoPedido?: { id: any } }
  ) {
    const preferTabela = options?.preferTabelaId;
    const copiaTipo = options?.copiaTipoPedido;
    this.aplicandoDadosCliente = true;
    try {
      this.errorClienteBloqueado = resp.bloqueiaPedidos;
      if (resp.bloqueiaPedidos) {
        this.erroMensagemBloqueio = resp.mensagemBloqueio;
      }
      
      this.usuarioService.getPedidoTipos(
        function (respPt: any) {
          this.pedidoTiposUsuario = respPt;
          if (this.pedidoTiposUsuario.length == 1) {
            this.form.controls.pedidoTipo.setValue(
              this.pedidoTiposUsuario[0].id
            );
          } else if (copiaTipo) {
            this.form.controls.pedidoTipo.setValue(copiaTipo.id);
            this.tipoSelecionado = copiaTipo.id;
          } else {
            this.form.controls.pedidoTipo.setValue("");
          }
        }.bind(this)
      );

      this.filiais = resp.filiais;
      this.tabelas = resp.tabela_preco
      this.filial_Estoque = resp.filial_estoque;
      this.setSelectedCliente(resp);
      this.addCliente(resp);

      if (resp.filiais.length < 2 && resp.filiais.length > 0) {
        this.form.controls.filial.setValue(resp.filiais[0].id, {
          emitEvent: false,
        });
        this.carregarTabelasPreco(resp.id, resp.filiais[0].id, preferTabela);
      } else {
        this.form.controls.tabela.setValue("");
        this.form.controls.filial.setValue("", { emitEvent: false });
      }

      if (resp.filial_estoque.length < 2 && resp.filial_estoque.length > 0) {
        this.form.controls.filialEstoque.setValue(resp.filial_estoque[0].id);
      } else {
        this.form.controls.filialEstoque.setValue("");
      }
    } finally {
      queueMicrotask(() => {
        this.aplicandoDadosCliente = false;
        this.clienteDetalheCarregando = false;
      });
    }
  }

  onSubmit() {
    if (this.abrindoPedido) {
      return;
    }

    if (this.selectedCliente.cidades.id === null) {
      let msg = $localize`Cidade não encontrada`;
      this.toastService.warning(msg, "", {
        timeOut: 4000,
      });
      return;
    }
    if (!this.listCliente.length) {
      this.error = true;
      this.errorMsg.push($localize`Selecione um ou mais clientes!`);
      return;
    }

    if (this.tabelas.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem tabela de preço!");
      this.toastService.warning($localize`Cliente sem ${this.SITE.labelTabela} de preço!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("tabela").value === "") {

      this.toastService.warning($localize`Selecione uma ${this.SITE.labelTabela}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    if (this.filiais.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem filial!");
      this.toastService.warning($localize`Cliente sem ${this.SITE.labelFilial}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("filial").value === "") {
      this.toastService.warning($localize`Selecione uma ${this.SITE.labelFilial}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    if (this.pedidoTiposUsuario.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem filial!");
      this.toastService.warning($localize`Cliente sem ${this.SITE.labelFilial}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("pedidoTipo").value === "") {
      this.toastService.warning($localize`Selecione uma um ${this.SITE.labelPedidoTipo}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    // if (!this.form.valid) {
    //   this.error = true;
    //   this.errorMsg = "Confira o formulário corretamente!";
    //   return;
    // }

    if (this.clienteIdErp[this.selectedCliente.id] === "") {
      this.toastService.warning($localize`Escolha um endereço`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    if (
      (this.filial_Estoque === "" || this.filial_Estoque.length === 0) &&
      this.initProvider.usaFilialEstoque
    ) {
      this.toastService.warning($localize`Cliente sem filial de estoque`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      return;
    } else if (
      this.form.get("filialEstoque").value === "" &&
      this.initProvider.usaFilialEstoque
    ) {
      this.toastService.warning($localize`Selecione uma filial de estoque`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      return;
    }

    if (
      this.form.valid &&
      !this.pedidoService.loading &&
      this.clienteIdErp[this.selectedCliente.id] !== ""
    ) {
      let filialId = this.form.get("filial").value;
      let tabelaId = this.form.get("tabela").value;
      let pedidoTipoId = this.form.get("pedidoTipo").value;
      let filialEstoqueId = this.form.get("filialEstoque").value;
      let pedidoClientes: OrderClient[] = [];
      let dataEntrega = "";
      if (this.SITE.mostraDataEntrega) {
        dataEntrega = formatDate(
          this.form.get("dataEntrega").value,
          "dd/MM/yyyy",
          "en"
        );
      }
      this.listCliente.forEach((c) => {
        pedidoClientes.push({
          idEnderecoErp: this.clienteIdErp[c.id],
          cliente: c.id,
          quantidade: 0,
          subtotal: 0,
          impostos: 0,
          acrescimo: 0,
          acrescimoPercent: 0,
          desconto: 0,
          descontoPercent: 0,
          total: 0,
        });
      });
      let formPedido = {
        clientes: pedidoClientes,
        filial: filialId,
        tabela: tabelaId,
        tipo: pedidoTipoId,
        dataEntrega: dataEntrega,
        filialEstoque: this.initProvider.usaFilialEstoque
          ? filialEstoqueId
          : null,
      };
      this.abrindoPedido = true;
      this.pedidoService.abrir(
        formPedido,
        function (resp) {
          this.pedidoService.select(resp);
          Swal.fire($localize`Pedido`, $localize`Aberto com sucesso!`, "success");

          if (
            this.pedido !== undefined &&
            Configuracoes.modoVisualizacaoCatalogo
          )
            window.localStorage.setItem(
              "visualizacaoModo",
              Configuracoes.modoVisualizacaoCatalogo
            );

          this.router.navigate(["/catalogo"]).finally(() => {
            this.abrindoPedido = false;
          });
          // this.logService.orderCreated(resp.id);
        }.bind(this),
        function (error) {
          this.abrindoPedido = false;
          if (error.status == 403) {
            //403 Forbidden
            let msg = $localize`Usuário não autenticado`;
            this.toastService.info(msg, "", {
              timeOut: 4000,
            });
            window.location.href = "/login";
            return
          }
          if (error.status) {
            this.toastService.error(error.error.detail, $localize`Produto`, {
              positionClass: "toast-bottom-left",
            });
          }
          let obj = JSON.parse(error._body);
          if (obj && obj.msg) {
            this.error = true;
            this.errorMsg = obj.msg;
          }
          if (obj && obj.detail) {
            this.error = true;
            this.errorMsg = [obj.detail];
          }
        }.bind(this)
      );
    }
  }

  async onCopySubmit() {
    if (this.abrindoPedido) {
      return;
    }

    try {
      // 🔹 Helper para mostrar warning e retornar falso
      const warn = (msg: string, title: string = $localize`Cliente`) => {
        this.toastService.warning(msg, title, { positionClass: "toast-bottom-right", timeOut: 4000 });
        return false;
      };

      const pedidoCopy = this.pedidoService.pedidoCopy;
      const clienteCopy = pedidoCopy?.clientes?.[this.pedidoService.index];
      const clienteCopyId = clienteCopy?.cliente?.id;

      if (!clienteCopyId) {
        return warn($localize`Cliente da cópia não encontrado`);
      }

      // const clienteSelecionadoCopy = this.listCliente.find(
      //   (c) => String(c.id) === String(clienteCopyId)
      // );

      if (!this.listCliente.length) return warn($localize`Selecione um ou mais clientes!`);

      // if (!clienteSelecionadoCopy) {
      //   return warn($localize`Cliente da cópia não encontrado`);
      // }

      // this.listCliente = [clienteSelecionadoCopy];
      this.selectedCliente = this.listCliente[0];
      // 🔹 Validações iniciais
      // return
      if (
        !this.selectedCliente?.cidade?.id &&
        !this.selectedCliente?.cidades?.id
      ) {
        return warn($localize`Cidade não encontrada`);
      }


      if (this.tabelas.length < 1) {
        warn($localize`Cliente sem ${this.SITE.labelTabela} de preço!`);
      } else if (!this.form.get("tabela")?.value) {
        return warn($localize`Selecione uma ${this.SITE.labelTabela}!`);
      }

      if (this.filiais.length < 1) {
        warn($localize`Cliente sem ${this.SITE.labelFilial}!`);
      } else if (!this.form.get("filial")?.value) {
        return warn($localize`Selecione uma ${this.SITE.labelFilial}!`);
      }

      if (this.pedidoTiposUsuario.length < 1) {
        warn($localize`Cliente sem ${this.SITE.labelPedidoTipo}!`);
      } else if (!this.form.get("pedidoTipo")?.value) {
        return warn($localize`Selecione um ${this.SITE.labelPedidoTipo}!`);
      }

      if (!this.clienteIdErp[this.selectedCliente.id]) {
        return warn($localize`Escolha um endereço`);
      }

      if (this.initProvider.usaFilialEstoque) {
        if (!this.filial_Estoque?.length) {
          return warn($localize`Cliente sem filial de estoque`);
        }
        if (!this.form.get("filialEstoque")?.value) {

          return warn($localize`Selecione uma filial de estoque`);
        }
      }

      if (!this.form.valid || this.pedidoService.loading) {
        return warn($localize`Confira o formulário corretamente!`);
      }

      // 🔹 Monta objeto pedido
      const pedidoClientes: OrderClient[] = this.listCliente.map(c => ({
        idEnderecoErp: this.clienteIdErp[c.id],
        cliente: c.id,
        quantidade: clienteCopy.quantidade,
        subtotal: clienteCopy.subtotal,
        impostos: clienteCopy.impostos,
        acrescimo: clienteCopy.acrescimo,
        acrescimoPercent: clienteCopy.acrescimoPercent,
        desconto: clienteCopy.desconto,
        descontoPercent: clienteCopy.descontoPercent,
        total: clienteCopy.total,
      }));
      // return
      const formPedido = {
        id: pedidoCopy.id,
        pedido_origem: clienteCopy.id,
        itens: pedidoCopy.itens
          .filter(
            i => String(i.cliente) === String(clienteCopyId)
          ),
        clientes: pedidoClientes,
        filial: this.form.get("filial")?.value,
        tabela: this.form.get("tabela")?.value,
        tipo: this.form.get("pedidoTipo")?.value,
        dataEntrega: this.SITE.mostraDataEntrega
          ? formatDate(this.form.get("dataEntrega")?.value, "dd/MM/yyyy", "en")
          : "",
        quantidade: clienteCopy.quantidade,
        subtotal: clienteCopy.subtotal,
        impostos: clienteCopy.impostos,
        acrescimo: clienteCopy.acrescimo,
        desconto: clienteCopy.desconto,
        total: clienteCopy.total,
        filialEstoque: this.initProvider.usaFilialEstoque
          ? this.form.get("filialEstoque")?.value
          : null,
      };
      // 🔹 Chamada ao serviço com tratamento de erro
      // return
      this.abrindoPedido = true;
      this.pedidoService.abrirCopy(
        formPedido,
        (resp) => {
          this.pedidoService.select(resp);
          Swal.fire($localize`Pedido`, $localize`Aberto com sucesso!`, "success");

          if (Configuracoes.modoVisualizacaoCatalogo) {
            window.localStorage.setItem("visualizacaoModo", Configuracoes.modoVisualizacaoCatalogo);
          }

          this.router.navigate(["/catalogo"]).finally(() => {
            this.abrindoPedido = false;
          });
        },
        (error) => {
          this.abrindoPedido = false;
          if (error.status === 403) {
            this.toastService.info($localize`Usuário não autenticado`, "", { timeOut: 4000 });
            window.location.href = "/login";
            return;
          }

          if (error.status && error.error?.detail) {
            this.toastService.error(error.error.detail, $localize`Produto`, { positionClass: "toast-bottom-left" });
          }

          try {
            const obj = JSON.parse(error._body);
            if (obj?.msg) {
              this.error = true;
              this.errorMsg = obj.msg;
            } else if (obj?.detail) {
              this.error = true;
              this.errorMsg = [obj.detail];
            }
          } catch {
            this.toastService.error($localize`Erro inesperado no servidor`, $localize`Pedido`);
          }
        }
      );
    } catch (e) {
      this.abrindoPedido = false;
      this.toastService.error($localize`Erro inesperado`, $localize`Pedido`);
      console.error("Erro onCopySubmit:", e);
    }
  }


  onSelect(event: TypeaheadMatch): void {
    const item = event.item;
    delete item.bloqueiaPedidos;
    this.selecionaCliente(event.item);
  }

  selecionaCliente(cliente: any) {
    this.errorClienteTabela = false;
    this.errorClienteBloqueado = false;
    if (cliente.bloqueiaPedidos) {
      this.errorClienteBloqueado = true;
    }

    this.clienteIdErp[cliente.id] = cliente.idEnderecoErp
      ? cliente.idEnderecoErp + ""
      : "";

    if (this.clienteDetalhadoEmMemoria(cliente)) {
      this.tabelas = [];
      this.form.controls.tabela.setValue("");
      this.aplicarDadosClienteAposCarregar(cliente);
      $("#cliente").val("");
      return;
    }

    this.clienteDetalheCarregando = true;
    this.tabelas = [];
    this.form.controls.tabela.setValue("");

    this.usuarioService.getClientesId(
      {
        id_cliente: cliente.id,
        id_usuario: this.initProvider.usuario.id,
      },
      (resp) => {
        this.aplicarDadosClienteAposCarregar(resp);
      }
    );
    $("#cliente").val("");
  }

  selecionaClienteCopy(cliente: any) {
    this.errorClienteTabela = false;
    this.errorClienteBloqueado = false;
    if (cliente.bloqueiaPedidos) {
      this.errorClienteBloqueado = true;
    }

    this.clienteIdErp[cliente.id] = cliente.idEnderecoErp
      ? cliente.idEnderecoErp + ""
      : "";

    const copiaTipo = this.pedidoService.pedidoCopy?.tipo;

    if (this.clienteDetalhadoEmMemoria(cliente)) {
      this.tabelas = [];
      this.form.controls.tabela.setValue("");
      this.aplicarDadosClienteAposCarregar(cliente, {
        copiaTipoPedido: copiaTipo,
      });
      $("#cliente").val("");
      return;
    }

    this.clienteDetalheCarregando = true;
    this.tabelas = [];
    this.form.controls.tabela.setValue("");

    this.usuarioService.getClientesId(
      {
        id_cliente: cliente.id,
        id_usuario: this.initProvider.usuario.id,
      },
      (resp) => {
        this.aplicarDadosClienteAposCarregar(resp, {
          copiaTipoPedido: copiaTipo,
        });
      }
    );
    $("#cliente").val("");
  }

  setSelectedCliente(c: any) {
    if (c.enderecos.length === 1) {
      this.clienteIdErp[c.id] = c.enderecos[0].id;
    }
    this.selectedCliente = c;
  }

  excluiCliente(c: any) {
    this.invalidarCacheTabelasCliente(c.id);
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) {
        this.listCliente.splice(i, 1);
        break;
      }
    }
    if (this.selectedCliente && this.selectedCliente.id == c.id) {
      if (this.listCliente.length) {
        this.selectedCliente = this.listCliente[this.listCliente.length - 1];
      } else {
        this.selectedCliente = null;
        this.clienteDetalheCarregando = false;
        this.tabelas = [];
        this.form.controls.tabela.setValue("");
      }
    }
    this.filiais = [];
  }

  excluiClienteCopy(c: any) {
    this.invalidarCacheTabelasCliente(c.id);
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) {
        this.listCliente.splice(i, 1);
        break;
      }
    }
    if (this.selectedCliente && this.selectedCliente.id == c.id) {
      if (this.listCliente.length) {
        this.selectedCliente = this.listCliente[this.listCliente.length - 1];
      } else {
        this.selectedCliente = null;
        this.clienteDetalheCarregando = false;
        this.tabelas = [];
        this.form.controls.tabela.setValue("");
      }
    }
  }

  addCliente(c: any) {
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) return;
    }
    this.listCliente.push(c);
  }
  selectTipo(e) {
    localStorage.setItem("tipoPedidoPre", e.target.value);
  }
  selecionaFilial(idFilial: any) {
    if (this.aplicandoDadosCliente) {
      return;
    }
    const fid =
      idFilial === null || idFilial === undefined ? "" : String(idFilial);
    if (fid === "") {
      this.tabelas = [];
      this.form.controls.tabela.setValue("");
      return;
    }
    let filial: any;
    for (var i = 0; i < this.filiais.length; i++) {
      if (String(this.filiais[i].id) === fid) {
        filial = this.filiais[i];
        break;
      }
    }
    if (!filial || !this.selectedCliente?.id) {
      return;
    }
    this.carregarTabelasPreco(this.selectedCliente.id, filial.id);
  }

  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
  }

  ngOnInit() {
    this.form
      .get("filial")
      .valueChanges.pipe(filter(() => !this.aplicandoDadosCliente))
      .subscribe((v) => this.selecionaFilial(v));
    if (this.initProvider.inicializaPedido) {
      this.toastService.warning("Usuário sem permissão para criar pedido", "Pedido")
      this.router.navigate(["/"]);
    }
    if (localStorage.getItem("tipoUsuario") === "PAINEL") {
      this.location.back();
    }
    if (!this.isCopy) {
      if (
        !this.pedidoService.confirmaAbandonarPedidoEmAberto()) {
        this.location.back();
      }
    } else {

      if (this.pedidoService.pedidoCopy === undefined) {
        this.router.navigate(["/pedidos"]);
        return;
      }
      const clienteCopy = this.pedidoService.pedidoCopy.clientes[this.pedidoService.index];
      const clienteCopyId = clienteCopy?.cliente?.id;
      if (!clienteCopyId) {
        this.router.navigate(["/pedidos"]);
        return;
      }
      this.usuarioService.getClientesId(
        {
          id_cliente: clienteCopyId,
          id_usuario: this.initProvider.usuario.id,
        },
        (resp) => {
          this.errorClienteBloqueado = resp.bloqueiaPedidos;
          if (resp.bloqueiaPedidos) {
            this.erroMensagemBloqueio = resp.mensagemBloqueio
          }
          this.usuarioService.getPedidoTipos(
            function (respPt) {
              this.pedidoTiposUsuario = respPt;
              if (this.pedidoTiposUsuario.length == 1) {
                this.form.controls.pedidoTipo.setValue(
                  this.pedidoTiposUsuario[0].id
                );
              } else {
                this.form.controls.pedidoTipo.setValue(this.pedidoService.pedidoCopy.tipo.id);
                this.tipoSelecionado = this.pedidoService.pedidoCopy.tipo.id
              }
            }.bind(this)
          );
          this.filiais = resp.filiais;
          this.filial_Estoque = resp.filial_estoque;
          this.setSelectedCliente(resp);
          this.listCliente = [resp];

          const filialCopyId = this.pedidoService.pedidoCopy.filial.id;
          const tabelaCopyId = this.pedidoService.pedidoCopy.tabela.id;

          this.aplicandoDadosCliente = true;
          try {
            this.form.controls["filial"].setValue(filialCopyId, {
              emitEvent: false,
            });
            this.form.controls.pedidoTipo.setValue(
              this.pedidoService.pedidoCopy.tipo.id
            );
          } finally {
            queueMicrotask(() => {
              this.aplicandoDadosCliente = false;
            });
          }
          this.carregarTabelasPreco(resp.id, filialCopyId, tabelaCopyId);
        }
      );
    }
  }
}
